import { fromJS } from 'immutable';

import { ApiUrl4,UserToken,SenderId } from '../../../helper/HelperAuth'
import { GlobalLoading } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (file,senderid) => async (dispatch, getState) => {
    dispatch({ type: GlobalLoading, showLoading: true, latestProcessStatus: false });

    const Authorization = UserToken;    

    
    const data = new FormData();
    data.append('file', file );
    console.log(file);
    const url2 = ApiUrl4 + 'config-waprofilepicture-set';

    var sender = senderid
    // if(sender == null || sender == "" || sender == undefined){
    //     sender = SenderId
    // }

    const argument2 = {  
        method: 'POST',
        headers : {
            'Content-Type':'image/png',
            'Authorization': Authorization,
            'senderid':sender
        },
        body : file
    };  
    const response2 = await doFetch(url2,argument2);   
    //debugger
    dispatch({ type: GlobalLoading, showLoading: false, latestProcessStatus : true });

    return response2;
};